const APARTMENT_PRINT_LIMIT = 100;

export default APARTMENT_PRINT_LIMIT;
